import React from "react";
import HomePage from "./HomePage";

/** Engagement workspace opens on Home (admin studio Home at /admin is separate). */
export default function PortalIndexRoute() {
  return <HomePage />;
}
